import { render, staticRenderFns } from "./Regist.vue?vue&type=template&id=1c193c87&scoped=true&"
import script from "./Regist.vue?vue&type=script&lang=js&"
export * from "./Regist.vue?vue&type=script&lang=js&"
import style0 from "./Regist.vue?vue&type=style&index=0&id=1c193c87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c193c87",
  null
  
)

export default component.exports